// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_34-1";
export var rateTableServiceLevelDropdown = "_34-3";
export var rateTableTypeDropdown = "_34-0";
export var rateTableValueModeDropdown = "_34-2";